import { Box, Paper } from "@material-ui/core";

import ReactECharts from "echarts-for-react";
import ReactEChartsCore from "echarts-for-react/lib/core";
import { useEffect, useRef } from "react";

import { useChartStyles } from "@/pages/caster/caster-data-entry-v2/components/charts/styles/useChartStyles";
import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { useTableStyles } from "@/pages/heat-report/styles/useTableStyles";
import { useChartOptions } from "./hooks/useChartOptions";

export const EAFChart = () => {
	const {
		state: {
			eafValues,
			heat: { HeatName },
		},
	} = useHeatReportContext();
	const classes = useTableStyles();
	const chartClasses = useChartStyles();
	const echartsRef = useRef<ReactEChartsCore>(null);

	const chartOptions = useChartOptions({ eafValues, heatName: HeatName });

	useEffect(() => {
		if (echartsRef.current) {
			const instance = echartsRef.current.getEchartsInstance();
			instance.setOption(chartOptions, {
				replaceMerge: ["series"],
				lazyUpdate: true,
			});
		}
	}, [chartOptions]);

	return (
		<Paper className={classes.borderAgGridTable} elevation={0}>
			<Box p={0}>
				<div>
					<ReactECharts
						ref={echartsRef}
						option={chartOptions}
						notMerge={false}
					/>
				</div>
			</Box>
		</Paper>
	);
};
